import { ServiceResponseError } from 'exceptions'
import { BaseServices, EHttpMethod, EHttpStatus } from 'services/base'
import { urls } from 'services/base/url'

import { TResponseInfo } from '../types'
import { buildCodeValidateResponse } from '../utils'
import { TResponseValidaCodigo, TRequestCodeValidationPayload, TResponseIsValidCode } from './types'

const request = (payload: TRequestCodeValidationPayload) =>
  BaseServices.request<TResponseValidaCodigo>({
    pathname: `${urls.GET_CODIGO_VALIDAR}/${payload.params.codigo}`,
    method: EHttpMethod.GET,
    host: process.env.REACT_APP_API_HOST_CONTA_DIGITAL,
    headers: { 'x-id-ficha-cadastral': payload.header.hsfc },
  })

export const getValidaCodigo = async (payload: TRequestCodeValidationPayload) => {
  try {
    const response = await request(payload)
    const responseData = response.data as unknown as TResponseIsValidCode
    response.status = responseData.isValid ? EHttpStatus.SUCCESS : EHttpStatus.UNPROCESSABLE_ENTITY

    const resp: TResponseInfo = buildCodeValidateResponse(response)

    payload.success && payload.success(resp)
  } catch (error: unknown) {
    if (error instanceof ServiceResponseError) {
      const errorCallback: TResponseInfo = buildCodeValidateResponse(error)
      payload.error && payload.error(errorCallback)
    }
  } finally {
    payload.finally && payload.finally()
  }
}
